import { baseTheme } from "theme/base"

export const MuiChip = {
  deleteIcon: {
    width: "auto",
    height: "auto",
    padding: 0,
    margin: 0,
    marginRight: baseTheme.spacing(),
    color: baseTheme.palette.common.black,
    "&:hover": {
      background: baseTheme.palette.grey[300],
      color: baseTheme.palette.common.black,
    },
  },
  label: {
    paddingLeft: baseTheme.spacing(),
    paddingRight: baseTheme.spacing(),
  },
  root: {
    backgroundColor: baseTheme.palette.grey[100],
    borderRadius: "10rem",
    color: baseTheme.palette.common.black,
  },
}
